import React, { useContext, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { EditExerciseDialog } from "./EditExerciseDialog";

export const SelectedExerciseItem = ({
  id,
  name,
  hold,
  repeat,
  timesperday,
  range,
  resistance,
  direction,
  bmname,
  instructions,
  onRemove,
  onChange,
}) => {
  const img = require(`../../assets/exercise/${bmname}.png`);
  const { darkMode } = useContext(ThemeContext);

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    onRemove(id);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true); // Open the dialog
  };

  const handleDialogClose = (e) => {
    e?.stopPropagation();
    setDialogOpen(false); // Close the dialog
  };

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        width: "475px",
        height: "120px",
        padding: 1,
        borderRadius: "5px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: darkMode
          ? getColors.thumbnailBorderDark
          : getColors.thumbnailBorderLight,
        background: darkMode
          ? getColors.thumbnnailBgDark
          : getColors.thumbnnailBgLight,
        cursor: "pointer",
        "&:hover": {
          borderColor: darkMode
            ? getColors.thumbnailTextDark
            : getColors.thumbnailTextLight,
        },
      }}
      onClick={handleDialogOpen} // Move the onClick handler here
    >
      <Box>
        <Box display={"flex"} alignItems={"center"}>
          <img src={img} alt="img" style={{ width: "100px", height: "75px" }} />
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              ml: "20px",
            }}
          >
            {name}
          </Typography>
        </Box>
        <Box display={"flex"}>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              ml: "15px",
            }}
          >
            {`Hold=${hold}`}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              mx: "20px",
            }}
          >
            {`Repeat=${repeat}`}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
            }}
          >
            {`PerDay=${timesperday}`}
          </Typography>
        </Box>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        width="max-content"
        sx={{
          borderRadius: "50%",
          padding: "20px",
          color: "#FF3D3D",
          bgcolor: "#FFE8E8",
          alignItems: "center",
          "&:hover": {
            color: "red",
          },
          ml: 4,
          mr: 2,
        }}
        onClick={handleClick}
      >
        <DeleteOutlinedIcon sx={{ fontSize: "30px" }} />
      </Box>
      <EditExerciseDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onSave={(value) => onChange(value)}
        exerciseData={{
          id,
          name,
          hold,
          repeat,
          timesperday,
          range,
          resistance,
          direction,
          bmname,
          instructions,
        }}
      />
    </Box>
  );
};
